import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { setUser(null); }
    setLoading(false);
  }, []);

  useEffect(() => {
    // If returning from Google OAuth callback, skip /me; AuthCallback handles it
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data); return data;
  };
  const register = async (email, password, name, extras = {}) => {
    const { getUtm } = await import("@/lib/api");
    const { data } = await api.post("/auth/register", { email, password, name, utm: getUtm(), ...extras });
    setUser(data); return data;
  };
  const logout = async () => { await api.post("/auth/logout"); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refresh: checkAuth }}>
      {children}
    </AuthCtx.Provider>
  );
}
